import { render, staticRenderFns } from "./NolaNovelCheckboxGroups.vue?vue&type=template&id=662d7ff4&scoped=true"
import script from "./NolaNovelCheckboxGroups.vue?vue&type=script&lang=ts"
export * from "./NolaNovelCheckboxGroups.vue?vue&type=script&lang=ts"
import style0 from "./NolaNovelCheckboxGroups.vue?vue&type=style&index=0&id=662d7ff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662d7ff4",
  null
  
)

export default component.exports